// Primary text
export const navy = '#050e2c';
export const navy60 = 'rgba(5, 14, 44, 0.6)';

// Secondary text
export const darkGrey = '#747575';

// Tertiary colors
export const grey = '#ccc';
export const lightGrey = '#e0e0e0';
export const deepDarkGray = '#5A5A5A';
export const crayola = '#A7B0BF';

// General
export const white = '#fff';
export const black = '#242E38';
export const red = '#ff3232';
export const lightRed = '#ffcccc';

// Page Background
export const offWhite = '#F8F9F9';

// Accents
export const teal = '#009194';
export const purple = '#484770';
export const gold = '#D1B985';
export const secondaryGold = '#F6F0E4';
export const pink = '#825278';
export const softBlue = '#D4E9F7';
export const blue = '#256E89';
export const blue3 = '#4699D6';
export const newBlueLine = '#50B2FA';
export const secondaryBlue3 = '#D6E9F7';
export const secondaryLightBlue = '#A9F2F3';
export const lightgrey1 = '#D9E5E9';
export const borderBlack = '#444';
export const softYellow = '#E9DEA5';
export const softGray = '#D4E9F7';
export const textBlue = '#256E89'; // '#4fb2fa';
export const chartBlue = '#3661A8';
export const burgundy = '#771641';
export const secondaryBurgundy = '#F5E4E8';
export const deepBlue = '#5A98D1';
export const darkBlue = '#CCCCD1';
export const aquaBlue = '#A9F2F3';

//v2
export const gradient = `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(136.85deg, #256E89 16.87%, #66c1e2 82.61%);`;

export const gradientText = `linear-gradient(
	136.85deg,
	${white} 16.87%,
	${white} 82.61%
)`;

export const gradientTextRadioButton = `linear-gradient(136.85deg, rgba(64, 97, 163, 0.1) 16.87%, rgba(90, 152, 209, 0.1) 82.61%);`;

export const gradientGreen = `linear-gradient(136.85deg, #009194 16.87%, #484770 82.61%);`;

//v2
export const gradientBlue = `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(136.85deg, #256E89 16.87%, #66c1e2 82.61%);`;

export const gradientGreen3 = `linear-gradient(
	136.85deg,
	rgba(0, 145, 148, 0.1) 16.87%,
	rgba(72, 71, 112, 0.1) 82.61%
)`;

//v2
export const gradientBlue3 = `linear-gradient(136.85deg, rgba(64, 97, 163, 0.1) 16.87%, rgba(90, 152, 209, 0.1) 82.61%);`;

export const gradientButtonBackgroundImage = `linear-gradient(rgba(0, 145, 148, 1), rgba(72, 71, 112, 1)), linear-gradient(136.85deg, #009194 16.87%, #484770 82.61%);`;

// Status background colors
export const blue200 = 'rgba(45,156,219, 0.2)';
export const blue2 = '#2D9CDB';
export const grey200 = 'rgba(116, 117,117, 0.2)';
export const yellow200 = 'rgba(242,201,76, 0.2)';
export const green200 = 'rgba(111,207,151, 0.2)';
export const red200 = 'rgba(235,87,87, 0.2)';

// Status text colors

// Other
export const red10 = 'rgba(251, 221, 221, 1)';
export const red80 = '#EB5757';
export const orange10 = 'rgba(252, 235, 219, 1)';
export const yellow10 = '#FCF4DB';
export const blue10 = 'rgba(45, 156, 219, 0.2)';
export const blue20 = '#3E859D';
export const green = '#009194';
export const graphPointGreen = '#6FCF97';
export const green10 = 'rgba(111, 207, 151, 0.2)';
export const green20 = 'rgba(0, 145, 148, 0.2)';
export const gold10 = 'rgba(209, 185, 133, 0.25)';

export const green70 = '#6FCF97';
export const green80 = '#27AE60';
export const yellow70 = '#F2C94C';
export const grey5 = 'rgba(72, 71, 112, 0.2)';
export const grey10 = '#F0F2F4';
export const grey20 = '#cccccc';
export const grey30 = '#F2F2F2';
export const grey40 = '#bdbdbd';
export const grey65 = '#5c5c5c';

export const purple10 = 'rgba(108, 105, 255, 0.2)';
export const chatPurple = '#cba2f0';

export const black20 = 'rgba(0, 0, 0, 0.2)';

export const hoverGreenText = 'rgb(0, 145, 148)';

export const hoverBlueText =
	'linear-gradient(136.85deg, #4061A3 16.87%, #5A98D1 82.61%);';
export const bgGreen = '#E2F5EA';

export const colors = {
	blue200,
	blue20,
	blue2,
	grey200,
	yellow200,
	softYellow,
	green200,
	red200,
	black,
	black20,
	darkGrey,
	gold,
	gold10,
	softBlue,
	softGray,
	gradient,
	gradientText,
	gradientGreen,
	gradientBlue,
	gradientGreen3,
	gradientBlue3,
	gradientTextRadioButton,
	gradientButtonBackgroundImage,
	green,
	green10,
	green20,
	green70,
	green80,
	grey,
	grey5,
	grey10,
	grey20,
	grey30,
	grey40,
	grey65,
	lightGrey,
	navy,
	navy60,
	offWhite,
	pink,
	purple,
	red,
	red80,
	red10,
	lightRed,
	orange10,
	teal,
	yellow10,
	yellow70,
	white,
	blue10,
	hoverBlueText,
	blue,
	blue3,
	secondaryLightBlue,
	newBlueLine,
	borderBlack,
	deepBlue,
	burgundy,
	secondaryBurgundy,
	textBlue,
	chartBlue,
	graphPointGreen,
	deepDarkGray,
	lightgrey1,
	crayola,
	bgGreen,
	purple10,
	chatPurple,
	darkBlue,
	aquaBlue,
};
